<main *ngIf="form">
    <tarifrechner-common-loading-screen [loading]="isLoading | async"
                                        text="Preis wird berechnet..."></tarifrechner-common-loading-screen>
    <div class="cyber-zusammenfassung h-spacer-l l-container l-container--m">
        <form [formGroup]="form">
            <div class="l-container l-container--m h-text-center">
                <h1 class="h-spacer-l">{{ currentSeite.seiteDefinition.label }}</h1>
                <div class="h-font-regular h-color-black">
                    <p class="h-font-m h-font-medium" style="margin:0">Unverbindlicher Nettobeitrag</p>
                    <h1 class="h-spacer-s h-font-xxl h-color-pri-dark">
                        {{ (beitragsdaten | async)?.gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}
                        <span class="h-font-m h-font-medium h-color-black">jährlich</span>
                    </h1>
                </div>

                <div class="h-font-regular h-color-black">
                    <span class="h-font-m">
                        Brutto
                        <strong>{{ (beitragsdaten | async)?.gesamtJahresBruttoBeitrag | currency:'EUR':'symbol-narrow' }}</strong>
                        jährlich
                        <br> <span class="h-font-s">(inkl. 19% Versicherungsteuer)</span>
                    </span>
                </div>
            </div>

            <h2 class="h-spacer-s h-text-left h-font-l">Ihre Bausteine&nbsp;<span
                class="h-font-s">(Angaben in Netto)</span></h2>

            <div class="h-spacer-l m-overview-table">
                <div class="m-overview-table__row">
                    <div class="h-text-left">
                        <span class="h-font-m m-overview-table__item-name">Grundbaustein</span>
                    </div>
                    <div class="h-text-right h-font-m h-color-pri-dark">
                        <span>{{ (beitragsdaten | async)?.beitraegeFuerBausteine.get('Grundbaustein').gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}</span>
                        <span>&nbsp;jährlich</span>
                    </div>
                </div>
                <div class="m-overview-table__row" *ngFor="let baustein of getBausteine() | keyvalue">
                    <div class="h-text-left">
                        <span
                            class="h-font-m m-overview-table__item-name">{{ getBausteinBezeichnungen(baustein.key) }}</span>
                    </div>
                    <div class="h-text-right h-font-m h-color-pri-dark">
                        <span>{{ baustein.value.gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}</span>
                        <span>&nbsp;jährlich</span>
                    </div>
                </div>
            </div>

            <div class="cyber-zusammenfassung__box l-container l-container--m" style="padding-top: 0.5rem;">
                <h2 class="h-font-l h-font-medium h-color-black">Ihre Vorteile auf einen Blick</h2>
                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    24/7-Soforthilfe durch zertifizierten IT-Dienstleister
                </p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    Fehlbedienung mitversichert
                </p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    Sachschäden an Hardware mitversichert
                </p>
            </div>

            <div class="l-container l-container--s">
                <button class="m-button m-button--full h-spacer-s weiter-button" type="button" (click)="onSubmit()">
                    <span>Weiter</span>
                </button>
            </div>

            <div class="l-container l-container--m" *ngIf="versicherungsBeginnElement && zahlweiseElement">
                <h2 class="h-spacer-m">Das Wichtigste in der Übersicht:</h2>

                <ul class="m-list m-list--icon m-list--icon-horizontal">
                    <li>
                        <svg class="icon">
                            <use xlink:href="#icon-calendar"></use>
                        </svg>
                        <span>
                            <strong>Versicherungsbeginn:</strong><br>
                            <form-element-selector
                                [element]="versicherungsBeginnElement"
                                [visible]="isVisible(versicherungsBeginnElement)"
                                [form]="form"
                                [submitted]="getSubmitted()"></form-element-selector>
                    </span>
                    </li>
                    <li>
                        <svg class="icon">
                            <use xlink:href="#icon-clock"></use>
                        </svg>
                        <span>
                        <strong>{{ versicherungsAblaufElement.attribut.label }}</strong><br>
                            {{ versicherungsAblaufElement.value }}
                    </span>
                    </li>
                    <li>
                        <svg class="icon">
                            <use xlink:href="#icon-euro"></use>
                        </svg>
                        <span>
            <strong>Zahlungsweise:</strong><br>jährlich


          </span>
                    </li>
                </ul>
            </div>
        </form>
    </div>

    <vhv-footer [show-next]="false" [page-reused]="isPageReused"></vhv-footer>
</main>
